<template>
  <div class="vue-form__form">
    <form-question
      :number="currentQuestionIndex + 1"
      :question="question"
      :show-number="question.type !== 'submit'"
    />
    <form-answer
      :question="question"
      :submit-btn-txt="submitBtnTxt"
      @answer="registerAnswer"
      @submit="submit"
    />
  </div>
</template>

<script>
import FormQuestion from "./FormQuestion";
import FormAnswer from "./FormAnswer";

export default {
  props: {
    buttons: Object,
    questions: Array,
    answers: []
  },
  data() {
    return {
      submitBtnTxt: this.buttons && this.buttons.submitBtnTxt ? this.buttons.submitBtnTxt : 'Submit',
      userAnswers: [],
      currentQuestionIndex: 0
    };
  },
  computed: {
    question() {
      return this.questions[this.currentQuestionIndex];
    }
  },
  components: {
    FormQuestion,
    FormAnswer
  },
  methods: {
    submit() {
      this.$emit("complete", this.userAnswers);
    },

    changeQuestion(newQuestionIndex) {
      if (!this.questions[newQuestionIndex]) {
        this.submit();
        return;
      }

      this.currentQuestionIndex = newQuestionIndex;
    },

    registerAnswer(answerData) {
      const question = answerData.question;
      const answer = answerData.answer;

      const action = answer.action || question.action;

      this.userAnswers.push({
        question: question.question,
        answer: answer.answer || answer
      });

      if (!action || action === "continue") {
        this.changeQuestion(this.currentQuestionIndex + 1);
        return;
      }

      if (action === "skip") {
        const questionIndex = this.questions.findIndex(
          q => q.id === answer.skipTo
        );
        this.changeQuestion(questionIndex);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-form__form {
  height: 100%;

  display: flex;
  flex-direction: column;
  margin-top:25px;

  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    width: calc((100% / 3) * 2);
  }
}
</style>
